import React from "react";
import StatesPageGen from "./generated/StatesPageGen";
import statesService from "../../../services/legacy/statesService";

const SHOW_IN_GRID = new Set(["stateid", "name", "countryid", "intrastatcode"]);
const SHOW_IN_FILTER = new Set(["stateid", "name", "countryid"]);

const transformColumns = (baseColumns) => {
  return baseColumns.map((column) => ({
    ...column,
    showInGrid: SHOW_IN_GRID.has(column.key),
    showInFilter: SHOW_IN_FILTER.has(column.key),
  }));
};

const StatesPage = () => {
  const service = statesService;
  return <StatesPageGen service={service} transformColumns={transformColumns} />;
};

export default StatesPage;